import { User } from "lucide-react"
import { PlaceholderPage } from "./placeholder-page"

export function MyProfilePage() {
  return (
    <PlaceholderPage
      icon={User}
      title="M\u00F3j profil"
      description="Zarz\u0105dzaj swoimi danymi osobowymi, adresem email, awatarem i has\u0142em."
    />
  )
}
